import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteTaskAction } from '../../../redux/actions/tasksActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';

const DeleteTaskModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const task = useSelector((state) => state.tasks?.task);

  const onSubmit = async () => {
    setLoading(true);
    await dispatch(deleteTaskAction(task.id));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Видалення послуги'}
      loading={loading}
      onClose={onModalClose}
      body={'Ви дійсно бажаєте видалити цю послугу?'}
      actionButton={<Button onClick={onSubmit} disabled={loading} variant={'primary'} children={'Видалити'} />}
    />
  );
};

export default DeleteTaskModal;
